export default __webpack_public_path__ + "static/media/blank_profile_photo.f5eac64d.png";